/**
 * Mobile-Navigation: Toggle über .js-nav__button / .nav__button,
 * Body-Klasse: .nav-open
 */
export function navigation() {
	const buttons = document.querySelectorAll('.js-nav__button, .nav__button')
	if (!buttons.length) return

	const body = document.body

	function toggleMenu() {
		const isOpen = body.classList.contains('nav-open')
		body.classList.toggle('nav-open', !isOpen)
		buttons.forEach((btn) => btn.classList.toggle('is-active', !isOpen))
	}

	function closeMenu() {
		body.classList.remove('nav-open')
		buttons.forEach((btn) => btn.classList.remove('is-active'))
	}

	buttons.forEach((btn) => {
		btn.addEventListener('click', toggleMenu)
	})

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && body.classList.contains('nav-open')) {
			closeMenu()
		}
	})
}
